<template>
<div>
  <div class="row">
    <div class="col">
      <button type="button"
        class="btn u-mb-20"
        @click="$router.go( -1 )"
      >
        <i class="fa fa-arrow-left"></i>
        &nbsp; Volver
      </button>
    </div>
    <template v-if="this.user.rol">
      <div v-if="this.user.rol.toLowerCase() == 'merani'" class="col">
        Inspirador: <strong>{{ this.inspiradorActual.nombres }} {{ this.inspiradorActual.apellidos }}</strong>
      </div>
    </template>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <ul class="nav nav-tabs nav-justified">
          <li class="nav-item">
            <a class="nav-link" @click.prevent="setActive('inspirado')" :class="{ active: isActive('inspirado') }" href="#inspirado">Detalle inspirado</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" @click.prevent="setActive('historiainspirado')" :class="{ active: isActive('historiainspirado') }" href="#historiainspirado">Historias</a>
          </li>
      </ul>
    </div>
    <div class="col-sm-12">
      <div class="tab-content pt-5">
        <div class="tab-pane fade" :class="{ 'active show': isActive('inspirado') }" id="inspirado">
          <card class="col-md-8 offset-md-2" header-text="Detalle de Inspirado">
              <ul v-if="Object.keys(inspirado).length" class="list-group list-group-flush">
                    <li class="list-group-item"><h4><span><strong>{{ `${inspirado.nombres} ${inspirado.apellidos}`  }}</strong></span></h4></li>
                    <li v-if="inspirado.edad" class="list-group-item">Edad: <span><strong>{{ inspirado.edad }}</strong></span></li>
                    <li class="list-group-item">Tipo identificación: <span><strong>{{ inspirado.tipoIdentificacion }}</strong></span></li>
                    <li class="list-group-item">Número identificación: <span><strong>{{ inspirado.numeroIdentificacion }}</strong></span></li>
                    <li class="list-group-item">Género: <span><strong>{{ inspirado.genero }}</strong></span></li>
                    <li class="list-group-item">Teléfono: <span><strong>{{ inspirado.telefono }}</strong></span></li>
                    <li class="list-group-item">Nacionalidad: <span><strong>{{ inspirado.pais }}</strong></span></li>
                    <li v-if="typeof inspirado.departamento.nombre != 'undefined'" class="list-group-item">Departamento: <span><strong>{{ inspirado.departamento.nombre }}</strong></span></li>
                    <li v-if="typeof inspirado.municipio.nombre != 'undefined'" class="list-group-item">Municipio: <span><strong>{{ inspirado.municipio.nombre }}</strong></span></li>
                    <li class="list-group-item">Dirección: <span><strong>{{ inspirado.direccion }}</strong></span></li>
                    <li class="list-group-item">Etnia: <span><strong>{{ inspirado.etnia }}</strong></span></li>
                    <li v-if="inspirado.victima" class="list-group-item">Víctima: <span><strong>Sí</strong></span></li>
                    <li v-if="inspirado.discapacidad" class="list-group-item">Discapacidad: <span><strong>Sí</strong></span></li>
                    <li v-if="inspirado.lgbti" class="list-group-item">Lgbti: <span><strong>Sí</strong></span></li>
                </ul>
          </card>
        </div>
        <div class="tab-pane fade" :class="{ 'active show': isActive('historiainspirado') }" id="historiainspirado">
          <card :header-text="`Historias (${inspirado.historias ? inspirado.historias.length : 0})`">
            <template v-slot:card-header>
              <router-link class="btn btn-action btn-small btn-success"
                :to="{ name: 'crear-historia', params: {id: keyInspirado}}"
              >
                <i class="fa fa-plus"></i>&nbsp;<span>Nueva Historia</span>
              </router-link>
            </template>
              <ul v-if="inspirado.historias" class="list-group list-group-flush">
                <li class="list-group-item" v-for="(historia, i) in inspirado.historias" v-bind:key="historia.id">
                  <small>
                    {{ historia.fechaCreacion.toDate().toLocaleString() }}
                  </small>
                  <h6>
                    Descripción:
                  </h6>
                  <p>
                    {{ historia.descripcion }}
                  </p>
                  <template v-if="historia.urlArchivo">
                      <a v-if="obtenerFormatoArchivo(historia.urlArchivo) == 'imagen'" :href="urlHistorias[i]" target="_blank">
                        <img :src="urlHistorias[i]" />
                      </a>
                    <template v-if="obtenerFormatoArchivo(historia.urlArchivo) == 'video'">
                      <video controls :src="urlHistorias[i]"></video>
                      <a  :href="urlHistorias[i]" target="_blank">
                        Ver en grande
                      </a>
                    </template>
                    <template v-if="obtenerFormatoArchivo(historia.urlArchivo) == 'audio'">
                      <audio controls :src="urlHistorias[i]"></audio>
                    </template>
                    <template v-if="obtenerFormatoArchivo(historia.urlArchivo) == 'diapositivas'">
                      <a  :href="urlHistorias[i]" target="_blank">
                        {{ historia.urlArchivo }}
                      </a>
                    </template>
                  </template>
                  <template v-if="historia.iframe">
                    <div v-html="historia.iframe"></div>
                  </template>
                </li>
              </ul>
              <p v-else>Aún no hay historias</p>
          </card>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import apiInspirado from '../../api/inspirados'
import apiStorage from '../../api/storage'
import { mapState, mapActions } from 'vuex'
import { etnias, generos, tiposDocumento } from '../../static-data/listas'
export default {
  data () {
    return {
      inspirado: {},
      keyInspirado: '',
      urlHistorias: [],
      activeItem: 'inspirado'
    }
  },
  async mounted () {
    if (this.user !== {}) await this.$store.dispatch('user/getUserInfo')
    await this.loadInspirado(this.$route.params.id)
    this.keyInspirado = this.$route.params.id

    if (this.user.rol && this.user.rol.toLowerCase() === 'merani') {
      if (!Object.keys(this.inspiradorActual).length) {
        await this.loadInspirador(this.inspirado.idInspirador.id)
      }
    }

    this.inspirado.tipoIdentificacion = tiposDocumento.filter(o => o.value === this.inspirado.tipoIdentificacion)[0].label
    this.inspirado.genero = generos.filter(o => o.value === this.inspirado.genero)[0].label
    // this.inspirado.organizacionTipo = instituciones.filter(o => o.value === this.inspirado.organizacionTipo)[0].label
    this.inspirado.etnia = etnias.filter(o => o.value === this.inspirado.etnia)[0].label
    if (this.inspirado.createdAt) {
      const tempDate = new Date(this.inspirado.createdAt)
      const dd = String(tempDate.getDate()).padStart(2, '0')
      const mm = String(tempDate.getMonth() + 1).padStart(2, '0')
      const yyyy = tempDate.getFullYear()
      this.inspirado.createdAt = dd + '/' + mm + '/' + yyyy
    }
  },
  methods: {
    loadHistorias () {
      const that = this
      const promises = []
      if (this.inspirado.historias) {
        this.inspirado.historias.forEach(historia => {
          if (historia.urlArchivo) {
            promises.push(this.storage.obtenerUrlArchivoPorNombre(historia.urlArchivo, String(that.inspirado.numeroIdentificacion)))
          }
        })
        return Promise.all(promises)
      }
      return []
    },
    obtenerUrlArchivo (nombreArchivo) {
      this.storage.obtenerUrlArchivoPorNombre(nombreArchivo).then(url => {
        return url
      }).catch(err => {
        console.error(err)
        return ''
      })
    },
    obtenerFormatoArchivo (urlArchivo) {
      const formato = urlArchivo.split('.').pop()
      return this.formatos[formato]
    },
    async loadInspirado (id) {
      const that = this
      const inspiradoDoc = await apiInspirado.obtenerInspiradoPorId(id)
      this.inspirado = inspiradoDoc.data()
      const urlHistorias = await this.loadHistorias()
      this.urlHistorias = this.urlHistorias.concat(urlHistorias)
      urlHistorias.forEach(url => {
        Object.assign(that.urlHistorias, { url })
      })
    },
    isActive (menuItem) {
      return this.activeItem === menuItem
    },
    setActive (menuItem) {
      this.activeItem = menuItem
    },
    ...mapActions('merani', [
      'loadInspirador'
    ])
  },
  computed: {
    ...mapState('user', [
      'token',
      'user'
    ]),
    ...mapState('merani', [
      'inspiradorActual',
      'keyInspiradorActual'
    ]),
    formatos () {
      return {
        'jpg': 'imagen',
        'png': 'imagen',
        'mp3': 'audio',
        'mp4': 'video',
        'mpg': 'video',
        'pptx': 'diapositivas',
        'ppt': 'diapositivas'
      }
    },
    storage () {
      return apiStorage
    }
  }
}
</script>
<style lang="scss" scoped>
  .u-mb-20 {
    margin-bottom: 20px;
  }
  video, audio {
    width: 100%;
  }
  .btn-small {
    font-size: 12px;
    padding: 5px 9px;
  }
  li>span{
    float:right;
  }
</style>
